import React from 'react'
import reactCSS from 'reactcss'
import { GithubPicker } from 'react-color'

export const COLORS = [
  '#ff001a',
  '#ff6f00',
  '#f5b700',
  '#9dff00',
  '#00ffff',
  '#4400ff',
  '#bb00ff'
]

export function getRandomColor() {
  return COLORS[Math.floor(Math.random() * COLORS.length)]
}

export const ColorPickerWrapper = (props) => {
  const [color, setColor] = React.useState(props.color ?? getRandomColor())
  const [displayColorPicker, setDisplayColorPicker] = React.useState(false)

  React.useEffect(() => {
    if (props.color) {
      let value = props.color
      if (!props.color.startsWith('#')) {
        value = `#${value}`
      }
      setColor(value)
    } else {
      setColor(getRandomColor())
    }
  }, [props.color])

  const handleClick = () => {
    if (props.onClick) {
      props.onClick()
    } else {
      setDisplayColorPicker(!displayColorPicker)
    }
  }

  const handleClose = () => {
    setDisplayColorPicker(false)
  }

  const handleChange = (color) => {
    props.onChange(color.hex)
  }

  const styles = reactCSS({
    default: {
      color: {
        width: '36px',
        height: '14px',
        borderRadius: '2px',
        background: color
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer'
      },
      popover: {
        position: 'absolute',
        zIndex: '2'
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px'
      }
    }
  })

  return (
    <div>
      <div style={styles.swatch} onClick={handleClick}>
        <div style={styles.color} />
      </div>
      {displayColorPicker ? (
        <div style={styles.popover}>
          <div style={styles.cover} onClick={handleClose} />
          {props.children}
        </div>
      ) : null}
    </div>
  )
}

const ColorPicker = (props) => {
  const handleChange = (color) => {
    props.onChange(color.hex)
  }

  return (
    <ColorPickerWrapper color={props.color}>
      <GithubPicker
        colors={COLORS}
        color={props.color}
        onChange={handleChange}
      />
    </ColorPickerWrapper>
  )
}

export default ColorPicker
